import React from 'react';

import {TSize} from '@edna/components';

import * as S from './style';

enum ELabelType {
  DEFAULT = 'DEFAULT',
  TOP = 'TOP',
  BLOCK = 'BLOCK',
}

type TProps = {
  className?: string;
  size?: TSize;
  labelType?: keyof typeof ELabelType;
  isOpenDefault?: boolean;
  disabled?: boolean;
  label: React.ReactNode;
  rightLabel?: React.ReactNode;
  children: React.ReactNode;
  noMargin?: boolean;
  noBorder?: boolean;
  arrowIcon?: TAnyComponent;
};

export const CollapsibleSection = React.memo<TProps>(
  ({
    className,
    label,
    rightLabel,
    disabled,
    isOpenDefault,
    size = 'M',
    labelType,
    children,
    noMargin,
    noBorder,
    arrowIcon,
  }) => {
    const labelComponent = React.useMemo(() => {
      switch (labelType) {
        case ELabelType.TOP:
          return S.TopCollapseLabel;
        case ELabelType.BLOCK:
          return S.BlockCollapseLabel;
        case ELabelType.DEFAULT:
        default:
          return S.CenterCollapseLabel;
      }
    }, [labelType]);

    return (
      <S.StatefulCollapse
        className={className}
        isOpenDefault={isOpenDefault}
        labelComponent={labelComponent}
        arrowIcon={arrowIcon ?? (size === 'L' ? S.LargeArrowIcon : S.ArrowIcon)}
        label={label}
        rightLabel={rightLabel}
        size={size}
        disabled={disabled}
        noMargin={noMargin}
        noBorder={noBorder}
      >
        <S.Children>{children}</S.Children>
      </S.StatefulCollapse>
    );
  },
);

export {ELabelType};
export {ArrowIcon, LargeArrowIcon} from './style';

export default CollapsibleSection;
